import React, { useState, useEffect, useCallback, useRef} from "react";
import Menu from "../../../../components/layout/menu/index";
import FilterInput from "../../../../components/filters/filterInput";
import '../../../../../src/index.css'
import ModalRefused from "../../../../components/shared/modals/modalRefused/index";
import RefusedForm from "../../../../components/shared/refusedForm";
import ModalSuccess from "../../../../components/shared/modals/modalSuccess";
import ListFilter from "../../../../components/filters/listFilters";
import DynamicTable from "../../../../components/tables/oc/provider/dynamicTable";
import { getTableConfig } from "../../../../components/tables/oc/provider/tableColumns";
import { useModuleAdherence } from "../../../../hooks/userAdherence";
import {GetActiveFalse, getListPurchaseOrderBySupplier, UpdatePdfOC, AcceptDeniedOC, UploadActivePivot } from ".././../../../client/purchaseOrder"
import { useAuth } from "../../../../context/auth";
import PdfViewerModal from "../../../../components/pdfViewer";
import ResetFilters from "../../../../components/filters/resetFilters";
import DateFilterButton from "../../../../components/filters/dateFilterButton";
import { format } from 'date-fns';
import ModalAlertWarning from "../../../../components/shared/modals/modalAlertWarning";
import { useNavigate } from "react-router-dom";
const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

const statusColors = {
  Aprobado: '#30EA06',
  Rechazado: '#E44949',
  Entregado: '#286AD4',
  Nuevo: '#00A3E0',
  Corregido: '#FF6A00',
  'Pendientes de entrega': '#FFB81C',
  Vencida: '#FF1C1C',
  "Creado": "#77A042"
};

<style>
{`
.table-simplebar .simplebar-scrollbar {
background: #007696;
border-radius: 20px;
width: 5px;
}

.table-simplebar .simplebar-scrollbar:before {
background: #007696 !important;
}
`}
</style>

const getDefaultDateRange = () => {
  const today = new Date();
  const twelveMonthsAgo = new Date();
  twelveMonthsAgo.setMonth(today.getMonth() - 12);
  
  return {
    startDate: format(twelveMonthsAgo, 'yyyy-MM-dd'),
    endDate: format(today, 'yyyy-MM-dd')
  };
};

export default function OCProvider() {
  useModuleAdherence(3);
  const navigate = useNavigate();
  const { supplierId } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

const [activeFalseIds, setActiveFalseIds] = useState({
  'Nuevas': [],
  'Pendientes de entrega': [],
  'Rechazadas': []
});

  const [activeTab, setActiveTab] = useState('Todas');
  const tabs = ['Todas', 'Nuevas', 'Pendientes de entrega', 'Rechazadas'];

  const [selectedRows, setSelectedRows] = useState([]);
  const [allSelectedIds, setAllSelectedIds] = useState([]); 

  const [showRadioButtons, setShowRadioButtons] = useState(false);

  const [loading,setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [purchaseOrders, setPurchaseOrders] = useState([]);

  //rechazar oc
  const [showModalRefused, setShowModalRefused] = useState(false);
  const [showRefusedForm, setShowRefusedForm] = useState(false);
  const [showRefusedSuccess, setShowRefusedSuccess] = useState(false);
  const [modalData, setModalData] = useState({ pos: '', oc: '' });

  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  const [searchTerm, setSearchTerm] = useState('');
  const [showAcceptSuccess, setShowAcceptSuccess] = useState(false);

  const [showPdfModal, setShowPdfModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');

const [showAlertWarning, setShowAlertWarning] = useState(false);
const [alertMessage, setAlertMessage] = useState('');

  const [resetFiltersFlag, setResetFiltersFlag] = useState(false);

  const [isTabChanging, setIsTabChanging] = useState(false);

  const [tempFilters, setTempFilters] = useState({
    centerCodes: [],
    hasMaterial: undefined,
    emissionDateFrom: '',
    emissionDateTo: '',
    statusIds: null
  });

  const [activeFilters, setActiveFilters] = useState({
    centerCodes: [],
    hasMaterial: undefined,
    emissionDateFrom: '',
    emissionDateTo: ''
  });

const isInitialLoad = useRef(true);
  const isFetching = useRef(false); 
  const lastFetchParams = useRef(''); 
    const debouncedSearchTerm = useDebounce(searchTerm, 500); 

  const statusMapping = {
    'Todas': null,
    'Nuevas': [19, 6],  //nuevo y corregido
    'Pendientes de entrega': [2, 3],  // vencida y pendientes de entrega
    'Rechazadas': [5] 
  };

  const [tabCounts, setTabCounts] = useState({
    'Nuevas': 0,
    'Pendientes de entrega': 0,
    'Rechazadas': 0
  });

const handleAgendarCita = (ocNumber = '') => {
  navigate('/agendar-cita', { 
    state: { 
      ocNumber: ocNumber 
    } 
  });
};

const fetchPurchaseOrders = useCallback(async () => {
  if (isFetching.current) {
    return;
  }

  const paramsKey = `${activeTab}-${currentPage}-${recordsPerPage}-${JSON.stringify(activeFilters)}-${debouncedSearchTerm}`;
  
  if (lastFetchParams.current === paramsKey && !isInitialLoad.current) {
    return;
  }

  try {
    isFetching.current = true;
    lastFetchParams.current = paramsKey;
    setLoading(true);
    setPurchaseOrders([]);

    let statusIdsToSend;
    if (activeTab === 'Todas') {
      statusIdsToSend = activeFilters.statusIds;
    } else {
      statusIdsToSend = statusMapping[activeTab];
    }

    const response = await getListPurchaseOrderBySupplier(
      supplierId,
      statusIdsToSend,
      activeFilters.centerCodes.length > 0 ? activeFilters.centerCodes : undefined,
      activeFilters.hasMaterial,
      activeFilters.emissionDateFrom || undefined,
      activeFilters.emissionDateTo || undefined,
      searchTerm.trim() !== '' ? searchTerm : undefined,
      activeFilters.deliveryDateFrom || undefined,
      activeFilters.deliveryDateTo || undefined,
      currentPage,
      recordsPerPage
    );


    if (response.data && response.data.data) {
      setPurchaseOrders(response.data.data);
      setTotalRecords(response.data.totalCount || 0);
      setTotalPages(response.data.totalPages || 1);
      setError(null);
    } else {
      console.warn('⚠️ La API no devolvió datos en el formato esperado:', response.data);
      setPurchaseOrders([]);
      setTotalRecords(0);
      setTotalPages(1);
    }
  } catch (err) {
    console.error('❌ Error en fetchPurchaseOrders:', err);
    setError(err.message || 'Error al cargar las órdenes');
    setPurchaseOrders([]);
    setTotalRecords(0);
    setTotalPages(1);
  } finally {
    setLoading(false);
    setIsTabChanging(false); 
    isFetching.current = false;
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
    }
  }
}, [supplierId, activeTab, activeFilters, searchTerm, currentPage, recordsPerPage, debouncedSearchTerm]);


const fetchTabCounts = async () => {
  try {
    const defaultDateRange = getDefaultDateRange();
    
    const [nuevasResponse, pendientesResponse, rechazadasResponse] = await Promise.all([
      GetActiveFalse([19, 6], supplierId, defaultDateRange.startDate, defaultDateRange.endDate),
      GetActiveFalse([2, 3], supplierId, defaultDateRange.startDate, defaultDateRange.endDate),
      GetActiveFalse([5], supplierId, defaultDateRange.startDate, defaultDateRange.endDate)
    ]);

    setTabCounts({
      'Nuevas': nuevasResponse.data?.activeFalseCount || 0,
      'Pendientes de entrega': pendientesResponse.data?.activeFalseCount || 0,
      'Rechazadas': rechazadasResponse.data?.activeFalseCount || 0
    });

    setActiveFalseIds({
      'Nuevas': nuevasResponse.data?.activeFalseIds || [],
      'Pendientes de entrega': pendientesResponse.data?.activeFalseIds || [],
      'Rechazadas': rechazadasResponse.data?.activeFalseIds || []
    });
  } catch (error) {
    console.error('Error fetching tab counts:', error);
  }
};

  useEffect(() => {
    // Si no hay supplierId, no hacer nada
    if (!supplierId) {
      setLoading(false);
      return;
    }

    // Si es la primera carga, ejecutar inmediatamente
    if (isInitialLoad.current) {
      fetchPurchaseOrders();
      return;
    }

    // Para cambios posteriores, usar debounce
    const timer = setTimeout(() => {
      fetchPurchaseOrders();
    }, 300);

    return () => clearTimeout(timer);
  }, [supplierId, activeTab, currentPage, recordsPerPage, activeFilters, debouncedSearchTerm]);


useEffect(() => {
  if (activeTab !== 'Todas' && activeTab !== 'Nuevas' && activeFalseIds[activeTab]?.length > 0) {
    const timer = setTimeout(() => {
      UploadActivePivot(activeFalseIds[activeTab])
        .then(response => {
          setPurchaseOrders(prev => prev.map(item => {
            if (activeFalseIds[activeTab].includes(item.id)) {
              return {
                ...item,
                status: {
                  ...item.status,
                  active: true
                }
              };
            }
            return item;
          }));
          fetchTabCounts();
        })
        .catch(error => {
          console.error('Error al marcar órdenes como vistas:', error);
        });
    }, 2000);

    return () => clearTimeout(timer);
  }
}, [activeTab, activeFalseIds]);


useEffect(() => {
  if (supplierId) {
    fetchTabCounts();
  }
}, [supplierId]);



  useEffect(() => {
    let timeoutId = null;

    const handleOCsUpdated = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        lastFetchParams.current = '';
        fetchPurchaseOrders();
      }, 300);
    };

    window.addEventListener('ocs-updated', handleOCsUpdated);
    
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('ocs-updated', handleOCsUpdated);
    };
  }, [fetchPurchaseOrders]);

useEffect(() => {
}, [purchaseOrders]);

const handleTabChange = (tab) => {

  if (activeTab === tab) return;
  
  const resetFilters = {
    centerCodes: [],
    hasMaterial: undefined,
    emissionDateFrom: '',
    emissionDateTo: '',
    statusIds: null,
    deliveryDateFrom: '',
    deliveryDateTo: '',
  };

  setTempFilters(resetFilters);
  setActiveFilters(resetFilters);
  setActiveTab(tab);
  setPurchaseOrders([]); 
  setIsTabChanging(true);
  setLoading(true); 
  setCurrentPage(1);
  setSelectedRows([]);
  setShowRadioButtons(false);
  setSearchTerm('');
};

useEffect(() => {
  if (activeTab !== 'Todas') {
    setTempFilters(prev => ({
      ...prev,
      statusIds: null
    }));
    setActiveFilters(prev => ({
      ...prev,
      statusIds: null
    }));
  }
}, [activeTab]);

//Filtros 

//Tipo de compra
const handleFilterChange = (filterTitle, value) => {
  if (filterTitle === "Tipo de compra:") {
    let hasMaterialValue;
    if (value === "Material") hasMaterialValue = true;
    else if (value === "Servicio") hasMaterialValue = false;
    else hasMaterialValue = undefined;
    
    setTempFilters(prev => ({
      ...prev,
      hasMaterial: hasMaterialValue
    }));
  } else if (filterTitle === "Estado de OC:") {
    setTempFilters(prev => ({
      ...prev,
      statusIds: value !== null ? [value] : []
    }));
  }
};
//Centro
const handleTempCenterCodesChange = (selectedCenterCodes) => {
  setTempFilters(prev => ({
    ...prev,
    centerCodes: selectedCenterCodes
  }));
};

const handleDateRangeChange = ({ startDate, endDate }) => {

  setTempFilters(prev => ({
    ...prev,
    emissionDateFrom: startDate,
    emissionDateTo: endDate
  }));
};

const applyFilters = () => {
  setActiveFilters(tempFilters); 
  setCurrentPage(1); 

};

const handleRecordsCountChange = (e) => {
  const newCount = Number(e.target.value);
  setRecordsPerPage(newCount);
  setCurrentPage(1); 
  fetchPurchaseOrders(); 
};

  const transformData = (data) => {
    const filteredData = (!searchTerm || typeof searchTerm !== 'string') 
    ? data 
    : data.filter(position => {
        const ocNumber = position.purchaseOrder?.order_number || '';
        return ocNumber.toLowerCase().includes(searchTerm.toLowerCase());
      });

  const startNumber = (currentPage - 1) * recordsPerPage + 1;

  const formatDecimal = (value) => {
    if (value === null || value === undefined) return '';
    const num = parseFloat(value);
    if (isNaN(num)) return '';
    
    return num.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };
  
  return filteredData.map((position, index) => {

    const daysValue = position.daysInfo?.daysOverdue !== null 
      ? position.daysInfo?.daysOverdue 
      : position.daysInfo?.daysRemaining;

    const daysType = position.daysInfo?.daysOverdue !== null ? 'Vencida' : 'Pendientes de entrega';
    return {
      id: position.id, 
      displayId: startNumber + index,
      numeroOC: position.purchaseOrder?.order_number || '',
      pos: position.position?.number || '',
      pedido: position.description || '',
      cantidad: position.cant ?? '',
      cantPedida: position.cant ?? '',
      cantPorEntregar: position.remainingToDeliver ?? '',
      unidad: position.unit_weight || '',
      estado: position.status?.status?.name, 
      fechaEmision: position.purchaseOrder?.emission_date?.toString() || '',
      fechaEntrega: position.delivery_Date?.toString() || '',
      moneda: position.coin || '',
      precio: formatDecimal(position.price_per_unit), 
      condicionPago: position.method_payment || '',
      centro: position.center_code || '',
      comprador: position.purchaseOrder?.user?.isPurchasingGroupUser || position.purchaseOrder?.user?.isAreaPositionUser
        ? position.purchaseOrder?.user?.name || ''
        : position.purchaseOrder?.user?.user_code || '',
      areaId: position.purchasingGroup?.area?.id || position.purchasingGroup?.areaId || null,
      material: position.material ||'',
      tipoEntrega: position.deliveryType ||'',
      descripcion: position.description || '',
      dias: daysValue !== null && daysValue !== undefined ? daysValue.toString() : '',
      daysType: daysType || '',
      verDetalle: () => handleViewDetails(position.purchaseOrder?.id),
      detalles: () => handleViewDetails(position.purchaseOrder?.id),
      descargar: () => handleDownloadPdf(position.purchaseOrder?.id),
      agendar: () => handleAgendarCita(position.purchaseOrder?.order_number || ''),
      status: {
        active: position.status?.active, 
        name: position.status?.status?.name,
      }
      };
    });
  };

  const transformedData = transformData(purchaseOrders);

  const [filterOptions, setFilterOptions] = useState([
    { 
      title: "Tipo de compra:", 
      options: ["Material", "Servicio", "Todos"] 
    },
    { 
      title: "Estado de OC:", 
    },
    { 
      title: "Año de creación:", 
      type: "dateRange"
    },
    { 
      title: "Fecha de entrega:", 
      type: "deliveryDateRange" 
    },
    { 
      title: "Centro:", 
    }
  ]);

const changePage = (page) => {
  if (page < 1 || page > totalPages) return;
  setCurrentPage(page);
};


const handleReject = () => {
  
  if (selectedRows.length === 0) {
    return;
  }
  
  const allSelectedItems = purchaseOrders.filter(position => 
    selectedRows.includes(position.id)
  );
  
  const selectedItems = transformData(allSelectedItems);
    const groupedByOC = selectedItems.reduce((acc, item) => {
    const ocNumber = item.numeroOC;
    if (!acc[ocNumber]) {
      acc[ocNumber] = [];
    }
    acc[ocNumber].push(item.pos);
    return acc;
  }, {});

let messageParts = [];
  for (const [ocNumber, positions] of Object.entries(groupedByOC)) {
    const uniquePositions = [...new Set(positions)]; 
    messageParts.push(`${uniquePositions.join(', ')} de la OC "${ocNumber}"`);
  }
  
  const fullMessage = messageParts.join(',\n');
  
  setModalData({
    pos: fullMessage,
  });
  setShowModalRefused(true);
};


  const handleAcceptRefused = () => {
    setShowModalRefused(false);
    setShowRefusedForm(true);
  };

const handleAcceptForm = async () => {
  try {
    
    await fetchTabCounts();
    
    setShowRefusedForm(false);
    setShowRefusedSuccess(true);
    setSelectedRows([]);
    setShowRadioButtons(false);
    await fetchPurchaseOrders(); 
  } catch (error) {
    console.error('Error al procesar el rechazo:', error);
  }
};

const handleSelectClick = () => {
  const newShowRadioButtons = !showRadioButtons;
  setShowRadioButtons(newShowRadioButtons);
  
  if (!newShowRadioButtons) {
    setSelectedRows([]);
    setAllSelectedIds([]);
  } else {
    setSelectedRows(allSelectedIds);
  }
};

useEffect(() => {
  if (!showRadioButtons) {
    setSelectedRows([]);
  }
}, [showRadioButtons]);

useEffect(() => {
  setShowRadioButtons(false);
  setSelectedRows([]); 
}, [activeTab]);

const handleCheckboxChange = (id) => {
  setSelectedRows(prev => {
    const newSelected = prev.includes(id) 
      ? prev.filter(selectedId => selectedId !== id) 
      : [...prev, id];
    return newSelected;
  });
};

const handleAccept = async () => {
  if (selectedRows.length === 0) {
    return;
  }

  try {
    const formData = new FormData();
    
    selectedRows.forEach(id => {
      formData.append('purchaseOrderPositionIds', id);
    });

    // StatusId 4 es para "Aprobado"
    formData.append('StatusId', 4);



    const response = await AcceptDeniedOC(formData);

    await fetchTabCounts();

    setShowAcceptSuccess(true);
    setSelectedRows([]);
    setShowRadioButtons(false);
    await fetchPurchaseOrders();

  } catch (error) {
    console.error('Error al aceptar las posiciones:', error);
  }
};

useEffect(() => {
  setSearchTerm(''); 
  if (activeTab !== 'Todas') {
    setTempFilters(prev => ({ ...prev, statusIds: null }));
    setActiveFilters(prev => ({ ...prev, statusIds: null }));
  }
}, [activeTab]);

const scrollToTop = () => {
    window.scrollTo({ 
      top: 100,
      behavior: "smooth" 
    });
  };

const handleViewDetails = async (purchaseOrderId) => {
  try {
    const response = await UpdatePdfOC(purchaseOrderId);
    
    if (response.data.pdfUrl) {
      setPdfUrl(response.data.pdfUrl);
      setShowPdfModal(true);
    } else if (response.data.message === "La orden de compra ya tiene un PDF asociado.") {
      setPdfUrl(response.data.pdfUrl);
      setShowPdfModal(true);
    } else {
      console.error("No se pudo obtener el PDF:", response.data.message);
    }
  } catch (error) {
    console.error("Error al actualizar el PDF:", error);
    
    if (error.response?.status === 404 && error.response?.data?.message) {
      setAlertMessage(error.response.data.message);
      setShowAlertWarning(true);
    } else if (error.response?.status === 400 && error.response?.data?.message) {
      setAlertMessage(error.response.data.message);
      setShowAlertWarning(true);
    } else {
      setAlertMessage("Error al cargar el PDF. Por favor intente nuevamente.");
      setShowAlertWarning(true);
    }
  }
};

const handleDownloadPdf = async (purchaseOrderId) => {
  try {
    
    const purchaseOrder = purchaseOrders.find(item => 
      item.purchaseOrder?.id === purchaseOrderId
    );
    
    const orderNumber = purchaseOrder?.purchaseOrder?.order_number || purchaseOrderId;
    const updateResponse = await UpdatePdfOC(purchaseOrderId);
    
    if (updateResponse.data.pdfUrl) {
      const pdfUrl = updateResponse.data.pdfUrl;
      
      const response = await fetch(pdfUrl);
      const blob = await response.blob();
      
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `OC_${orderNumber}.pdf`;
      
      document.body.appendChild(link);
      link.click();
      
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
    } else if (updateResponse.data.message === "La orden de compra ya tiene un PDF asociado." && updateResponse.data.pdfUrl) {
      const pdfUrl = updateResponse.data.pdfUrl;
      
      const response = await fetch(pdfUrl);
      const blob = await response.blob();
      
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `OC_${purchaseOrderId}.pdf`;
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
    } else {
      console.error("No se pudo obtener el PDF para descargar:", updateResponse.data.message);
      setAlertMessage("No se pudo obtener el PDF para descargar.");
      setShowAlertWarning(true);
    }
    
  } catch (error) {
    console.error("Error al descargar el PDF:", error);
    
    if (error.response?.status === 404 && error.response?.data?.message) {
      setAlertMessage(error.response.data.message);
      setShowAlertWarning(true);
    } else if (error.response?.status === 400 && error.response?.data?.message) {
      setAlertMessage(error.response.data.message);
      setShowAlertWarning(true);
    } else {
      setAlertMessage("Error al descargar el PDF. Por favor intente nuevamente.");
      setShowAlertWarning(true);
    }
  }
};


const handleResetFilters = () => {
  const newFilters = {
    centerCodes: [],
    hasMaterial: undefined,
    emissionDateFrom: '', 
    emissionDateTo: '',
    statusIds: activeTab !== 'Todas' ? statusMapping[activeTab] : null,
    deliveryDateFrom: '',
    deliveryDateTo: '',
  };

  setTempFilters(newFilters);
  setActiveFilters(newFilters);
  setCurrentPage(1);
  setSearchTerm('');
  setResetFiltersFlag(prev => !prev);
};

  return (
    <div>
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
      <div className={`flex-1 pt-[67px] transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"}  bg-[#F7F8F9] w-full z-50 min-h-screen`}>
        <div className="pt-4 md:pt-8 pb-10 px-[3%]">
          <div className="flex flex-col justify-between w-full gap-2 pb-6 items-left sm:items-center lg:flex-row">
            <h1 className="text-2xl md:text-[32px] text-blue font-itcbold">Mis Órdenes de Compra</h1>
            <div className="flex flex-col items-center justify-between gap-3 sm:flex-row sm:gap-3">
              {activeTab !== 'Rechazadas' && (
                <div className="flex items-end md:items-center">
                <FilterInput
                  placeholder="Buscar OC"
                  value={searchTerm}
                  onChange={(e) => {
                      const inputValue = e.target.value;
                      if (inputValue === '' || /^[0-9]*$/.test(inputValue)) {
                          setSearchTerm(inputValue);
                          setCurrentPage(1); 
                      }
                  }}
                  classname=" sm:w-auto md:w-full"
                />
                </div>
              )}
              <div className="flex items-center gap-3">
              {activeTab !== 'Todas' && (
                <DateFilterButton 
                  onDateRangeChange={({ startDate, endDate }) => {
                    setTempFilters(prev => ({
                      ...prev,
                      emissionDateFrom: startDate,
                      emissionDateTo: endDate
                    }));
                    setActiveFilters(prev => ({
                      ...prev,
                      emissionDateFrom: startDate,
                      emissionDateTo: endDate
                    }));
                    setCurrentPage(1);
                  }}
                  activeFilters={activeFilters}
                  title="Fecha de creación:"
                />
              )}
              
              {activeTab === 'Todas' && (
              
              <ListFilter 
                titleOption="Filtrar por"
                filters={filterOptions}
                classname="w-[110px]"
                onCenterCodesChange={handleTempCenterCodesChange}
                onFilterChange={handleFilterChange}
                onDateRangeChange={handleDateRangeChange}
                onDeliveryDateRangeChange={({ startDate, endDate }) => {
                  setTempFilters(prev => ({
                    ...prev,
                    deliveryDateFrom: startDate,
                    deliveryDateTo: endDate
                  }));
                }}
                applyFilters={applyFilters}
                resetStatusFilter={activeTab !== "Todas"}
                resetFlag={resetFiltersFlag}
                activeFilters={activeFilters}
              />
              )}
              <ResetFilters
              borderColor="border-blue-light"
              textColor="text-[#6B7280]"
              font="font-itcbook"
              onClick={handleResetFilters}
              />
              </div>
            </div>
          </div>
          
          <div className="flex flex-col items-end justify-between gap-4 md:items-center lg:flex-row ">
            <div className="flex flex-col lg:w-[75%]  w-full overflow-x-auto scrollbar-hide"> 
              <nav className="flex "> 
                {tabs.map((tab) => (
                  <button
                    key={tab}
                    className={`px-5 border-b-[3px] border-blue lg:border-none h-[54px] md:h-[64px]  font-itcmedium rounded-t-xl flex items-center justify-between gap-2 flex-shrink-0 whitespace-nowrap 
                      ${activeTab === tab ? 'text-white bg-blue cursor-default' : 'text-blue bg-white cursor-pointer'}`}
                    onClick={() => handleTabChange(tab)}
                    disabled={activeTab === tab}
                  >
                    <p className="text-sm md:text-lg font-itcmedium">{tab}</p>
                     
                    {tab !== 'Todas' && tabCounts[tab] > 0 && (
                      <div className="p-1 text-sm px-[9px] inline-block text-white rounded-full font-itcbold  bg-red-dark">
                        {tabCounts[tab]}
                      </div>
                    )}
                      
                  </button>
                  
                ))}
              </nav>
              <div className="bg-blue hidden lg:block h-[3px] w-full"></div>
            </div>


            {activeTab === 'Nuevas' && (
            <div className="flex justify-end w-full lg:w-[25%]">
              <button
                onClick={handleSelectClick}
                className={`text-white font-itcmedium rounded-lg p-2 px-4 flex-shrink-0 ${showRadioButtons ? 'bg-blue' : 'bg-[#58B6E5]'}`}
              >
                Seleccionar
              </button>
            </div>
            )}

          </div>

          <div>
            {activeTab !== 'Rechazadas' && (
              <div className="flex items-center justify-between my-4">
                <div className="flex items-center space-x-2 text-sm font-itcbook">
                  <p >Mostrar</p>
                  <div className="border-[#D1D5DB] border-[1px] rounded-md w-[58px] flex justify-center items-center h-[40px]">
                    <select
                      className="w-full h-full px-2 text-sm bg-white rounded-md outline-none cursor-pointer font-itcbook"
                      value={recordsPerPage}
                      onChange={handleRecordsCountChange}  
                    >
                      <option value={10}>10</option>
                      <option value={15}>15</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                    </select>
                  </div>
                  <p >Registros</p>
                </div>
              </div>
            )}

            {activeTab === 'Rechazadas' && (
              <div className="flex flex-col-reverse items-start justify-between gap-3 my-4 md:items-center md:flex-row">
                  <div className="flex items-center space-x-2 text-sm font-itcbook">
                    <p >Mostrar</p>
                    <div className="border-[#D1D5DB] border-[1px] rounded-md w-[58px] flex justify-center items-center h-[40px]">
                      <select
                        className="w-full h-full px-2 text-sm bg-white rounded-md outline-none font-itcbook"
                        value={recordsPerPage}
                        onChange={handleRecordsCountChange}  
                      >
                        <option value={10}>10</option>
                        <option value={15}>15</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                      </select>
                    </div>
                    <p >Registros</p>
                  </div>
                  
                  <FilterInput
                    title="Buscar OC"
                    value={searchTerm}
                    placeholder="Buscar OC"
                    onChange={(e) => {
                        const inputValue = e.target.value;
                        if (inputValue === '' || /^[0-9]*$/.test(inputValue)) {
                            setSearchTerm(inputValue);
                            setCurrentPage(1); 
                        }
                    }}
                  />
              </div>
            
            )}

                <DynamicTable 
          data={transformedData} 
          config={getTableConfig(activeTab)} 
          showRadioButtons={showRadioButtons}
          selectedRows={selectedRows}
          onCheckboxChange={handleCheckboxChange}
          currentPage={currentPage}
          totalPages={totalPages}
          changePage={changePage}
          recordsPerPage={recordsPerPage}
          totalRecords={totalRecords}
          statusColors={statusColors}
          scrollToTop={scrollToTop}
          loading={loading || isTabChanging}
          isOCProvider={activeTab !== 'Todas'}
          onSelectAll={(selectAll) => {
            if (selectAll) {
              const pageIds = transformedData.map(item => item.id);
              setSelectedRows(pageIds);
            } else {
              setSelectedRows([]);
            }
          }}
          allSelected={selectedRows.length === transformedData.length && transformedData.length > 0}
        />  
      

    

            {activeTab === 'Nuevas' && (
              <>
              <div>
                <div className={`fixed z-10  transform -translate-x-1/2 bottom-4 left-1/2 
                      ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"}`}>
                  <div className="flex gap-3 ">
                    <button
                      onClick={selectedRows.length > 0 ? handleAccept : undefined}
                      disabled={selectedRows.length === 0}
                      className={`p-3 w-[120px] text-lg flex items-center justify-center h-[50px] text-white rounded-md  font-itcmedium
                        ${selectedRows.length > 0 
                          ? "bg-green text-white cursor-" 
                          : "bg-gray cursor-not-allowed"}
                      `}>
                      Aceptar
                    </button>
                    <button
                      onClick={selectedRows.length > 0 ? handleReject : undefined}
                      disabled={selectedRows.length === 0}
                      className={`p-3 w-[120px] text-lg h-[50px] flex items-center justify-center bg-[#F7F8F9] rounded-md border-[2px]  font-itcmedium
                        ${selectedRows.length > 0 
                            ? " text-red border-red cursor-pointer " 
                            : " text-gray border-gray cursor-not-allowed"}
                      `}>
                      Rechazar
                    </button>
                  </div>
                </div>
              </div>
              </>
            )}
            {showPdfModal && (
              <PdfViewerModal
                pdfFile={pdfUrl}
                onClose={() => setShowPdfModal(false)}
              />
            )}

            <ModalRefused
              showModalRefused={showModalRefused}
              closeModal={() => setShowModalRefused(false)}
              accept={handleAcceptRefused}
              pos={modalData.pos}
              oc={modalData.oc}
            />

            <RefusedForm
              showModalRefused={showRefusedForm}
              closeModal={() => setShowRefusedForm(false)}
              accept={handleAcceptForm}
              selectedRows={selectedRows}
            />

            <ModalSuccess
              showModalSuccess={showAcceptSuccess}
              closeModalSuccess={() => setShowAcceptSuccess(false)}
              text="Las órdenes se han aceptado correctamente"
              fill="green" 
            />

            <ModalSuccess
              showModalSuccess={showRefusedSuccess}
              closeModalSuccess={() => setShowRefusedSuccess(false)}
              text="El envío de su OC rechazada se realizó correctamente"
              fill="green"
            />

<ModalAlertWarning
  showModalAlertWarning={showAlertWarning}
  closeModal={() => setShowAlertWarning(false)}
  error={alertMessage}
  accept={() => setShowAlertWarning(false)}
/>

          </div>
        </div>
      </div>
    </div>
  );
}